import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateUserComponent } from './create-user/create-user.component';
import { EntityListComponent } from './entity-list/entity-list.component';
import { EntitySearchComponent } from './entity-search/entity-search.component';
import { EntityViewAndEditComponent } from './entity-view-and-edit/entity-view-and-edit.component';
import { UserActivationComponent } from './user-activation/user-activation.component';
import { UserSearchComponent } from './user-search/user-search.component';
import { UserViewAndEditComponent } from './user-view-and-edit/user-view-and-edit.component';
import { UsersListComponent } from './users-list/users-list.component';
import { PendingUsersComponent } from './pending-users/pending-users.component';
import { CreateEntityBrokerComponent } from './create-entity-broker/create-entity-broker.component';
import { CreateEntityAgentComponent } from './create-entity-agent/create-entity-agent.component';
import { CreateBranchComponent } from './create-branch/create-branch.component';



const routes: Routes = [
  { path: '', redirectTo: 'create-user', pathMatch: 'full' },
  { path: 'create-user', component: CreateUserComponent },
  { path: 'pending-users', component: PendingUsersComponent },
  { path: 'users-list', component: UsersListComponent },
  { path: 'user-view-and-edit', component: UserViewAndEditComponent },
  { path: 'user-activation', component: UserActivationComponent },
  { path: 'user-search', component: UserSearchComponent },
  { path: 'entity-list', component: EntityListComponent },
  { path: 'entity-search', component: EntitySearchComponent },
  { path: 'entity-view-and-edit', component: EntityViewAndEditComponent },
  { path: 'entity-create-broker', component: CreateEntityBrokerComponent },
  { path: 'entity-create-agent', component: CreateEntityAgentComponent },
  { path: 'create-branch', component: CreateBranchComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrationRoutingModule { }
